module.exports = __webpack_public_path__ + "img/hr-tree-09-a-trunk.cb3d5270.png";